import { useSearchParams } from "react-router-dom";
import ListLeads from "./List";
import NoPhoneNumber from "./NoPhoneNumber";

const InboundCall = () => {
  const [params] = useSearchParams();
  const stripUSCountryCode = (number) => {
    if (!number) return number;

    const cleaned = number.trim();

    if (cleaned.startsWith("+1")) {
      return cleaned.slice(2);
    }

    if (cleaned.startsWith("1") && cleaned.length === 11) {
      return cleaned.slice(1);
    }

    return cleaned;
  };
  const receivedNumber = stripUSCountryCode(params.get("number"));
  const dialledNumber = stripUSCountryCode(params.get("dialled"));
  const receivedReg = stripUSCountryCode(params.get("registration"));

  if (!receivedNumber && !receivedReg) {
    return <NoPhoneNumber />;
  }

  return (
    <ListLeads
      receivedNumber={receivedNumber}
      receivedReg={receivedReg}
      dialledNumber={dialledNumber}
    />
  );
};

export default InboundCall;
